import styled from "styled-components";
import { Icon, RowView } from "../style/common_style";
import { useNavigate } from "react-router-dom";

interface TopBarProps {
  title: string;
  color?: string;
}

const TopBar = ({ title, color }: TopBarProps) => {
  const Navigate = useNavigate();
  const goBack = () => {
    Navigate(-1);
  };
  return (
    <Topbar color={color}>
      {color !== "white" ? (
        <BackBtn
          src={require("../../Image/ic_left_white.png")}
          onClick={goBack}
        />
      ) : (
        <BackBtn
          src={require("../../Image/ic_left_black.png")}
          onClick={goBack}
        />
      )}
      {title}
    </Topbar>
  );
};
export default TopBar;

const Topbar = styled(RowView)<{ color?: string }>`
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  top: 0;
  max-width: 500px;
  background-color: ${(props) =>
    props.color === "white" ? "white" : "#2d2d2d"};
  padding: 15px;
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
  position: relative; /* 추가 */
`;

const BackBtn = styled(Icon)`
  position: absolute;
  left: 16px;
  align-self: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
